<template>
	<tile-card
		elevation="0"
		aspect-ratio="1.5"
		:disabled="loading"
		@click="navigate"
	>
		<v-list-item class="flex-title" two-line>
			<v-list-item-content>
				<div class="user-type overline">
					{{ title }}
				</div>
				<v-list-item-title class="name headline">
					{{ subtitle }}
				</v-list-item-title>
			</v-list-item-content>
		</v-list-item>

		<div class="body">
			<v-icon color="grey lighten-1">fa-building</v-icon>
		</div>

		<template #actions>
			<v-spacer />
			<v-btn class="action-btn" :ripple="false" text>
				{{ actionText }}
				<v-icon class="ml-2" x-small>fa fa-arrow-right</v-icon>
			</v-btn>
		</template>
	</tile-card>
</template>

<script>
import _ from "lodash";

import TileCard from "../../shared/TileCard";

export default {
	components: { TileCard },

	props: ["loading", "community"],

	computed: {
		communityId() {
			const propCommunityId = _.get(this.community, "id");
			const paramCommunityId = _.get(this.$route, "params.communityId");
			return propCommunityId || paramCommunityId || null;
		},

		title() {
			if (this.communityId || this.loading) return "Community";
			else return "Select Community";
		},

		subtitle() {
			return (
				_.get(this.community, "name") ||
				_.get(this.$route, "params.communityId")
			);
		},

		actionText() {
			return this.communityId ? "View Community" : "Select Community";
		}
	},

	methods: {
		navigate() {
			if (this.communityId) {
				return this.$router.push({
					name: "Live Community",
					params: { communityId: this.communityId },
				});
			}

			return this.$router.push({ name: "Live Community Select" });
		},
	},
};
</script>
